import { Link } from "@remix-run/react";
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface Service {
  slug: string;
  inaTitle: string;
}

interface District {
  slug: string;
  district: string;
  services: Service[];
}

interface Props {
  data: District[];
}

export const GlobalScrollCardAllServices = ({ data }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <>
      <div className="relative">
        {/* Chevron buttons */}
        <button
          type="button"
          onClick={scrollLeft}
          aria-label="Previous slide"
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow"
        >
          <ChevronLeft className="w-5 h-5" aria-hidden="true" />
        </button>

        <button
          type="button"
          onClick={scrollRight}
          aria-label="Next slide"
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow"
        >
          <ChevronRight className="w-5 h-5" aria-hidden="true" />
        </button>

        {/* Scrollable container */}
        <div
          ref={scrollRef}
          className="no-scrollbar overflow-x-auto flex gap-4 px-10 scroll-smooth scrollbar-hide"
        >
          {data.map((district) =>
            district.services.map((service) => (
              <Link
                key={service.slug}
                to={`/jasa-bangun-rumah-di-bekasi/${district.slug}/${service.slug}`}
                className="min-w-[250px] flex-shrink-0 border bg-white p-4 rounded hover:bg-gray-100 text-black"
              >
                <h2 className="text-md font-semibold">{service.inaTitle}</h2>
                <p className="text-sm text-gray-600">{district.district}</p>
              </Link>
            ))
          )}
        </div>
      </div>
      <div className="pb-[10rem] lg:pb-[15rem]" />
    </>
  );
};
